/**
 * Created by intellicar-rinas on 22/9/17.
 */
import React, { Component } from "react";
import { connect } from "react-redux";
import "./ReportWindow.scss";
import Dom from "../../helpers/Dom";
import actions from "../../store/actions";
import InMultiSelect from "./schema/InMultiSelect/InMultiSelect";
import InWidgetWrapper from "./schema/InWidgetWrapper/InWidgetWrapper";
import { schemaTypes } from "../../constants/constants";
import InDatePicker from "./schema/InDatePicker/InDatePicker";
import InTable from "./schema/InTable/InTable";
import InGraph from "./schema/InGraph/InGraph2";
import InPieChart from "./schema/InPieChart/InPieChart";
import InGraphControl from "./schema/InGraphControl/InGraphControl";
import InGraphSet from "./schema/InGraphSet/InGraphSet";
import InGreySpotter from "./schema/InGreySpotter/InGreySpotter";
import AggregatedReport from "./schema/AggregatedReport/AggregatedReport";
import EVReport from "./schema/EVReport/EVReport"
import MobileyeReportToolBar from "./schema/MobileyeReportToolBar/MobileyeReportToolBar";
import TVSReportWidget from "./schema/TVSReportWidget/TVSReportWidget";
import _ from "lodash";
import LiabilityGuage from "./schema/LiabilityGuage/LiabilityGuage";
import ReactGA from "react-ga";
import AdvandedFuelReport from "../../Layouts/config/reports/advancedFuelReport/AdvancedFuelReportWidget";
import IntAnalytics from "../../IntAnalytics";
import stationmarker from "../InMap/Map/Markers/railway_station_icon.png";
import RailwayReportWidget from "../../Layouts/config/reports/railwaysReport/RailwayReportWidget";
import TripDetailsWidget from "../TripDetailsWidget/TripDetailsWidget";
import { getLogoWidth } from "../Header/Header";
// import mixpanel from "mixpanel-browser";
import Toggle from "../ToggleButton/index"
import Toggle2 from "./schema/ToggleButton2/Toggle2";
import SnapToggle from '../ToggleButton/snapToggle';
import {getCanDataReport} from '../../Layouts/config/reports/canDataReport'
import { getjemCanDataReport } from "../../Layouts/config/reports/jemCanDataReport";
import SwiggyWidget from "./schema/SwiggyWidget/SwiggyWidget";
import CanDataReport from "./schema/CanDataReport/CanDataReport";
import DownloadReport from "./schema/DownloadReport/DownloadReport";
import MonthlyReport from "./schema/MonthlyReport/MonthlyReport";
import moment  from "moment";
import { changeVehicle } from '../../Layouts/config/reports/historyReport/historyReport';
import DatePicker2 from "./schema/datePicker2/DatePicker2";
import GroupReport from "./schema/GroupReport/GroupReport"
import CmdStatusReport from "../../components/ReportWindow/schema/CmdStatusReport/CmdStatusReport";
import TripwiseReport from "../../components/ReportWindow/schema/TripwiseReport/TripwiseReport"
// import {clearData} from "./../../Layouts/config/reports/tripReport"
import GroupSelect from '../GroupSelect/GroupSelect'
import { getbgCanDataReport } from "../../Layouts/config/reports/bgCanDataReport";


// let stations = [
//     [12.747310, 78.339938, 'Kuppam', 'KPN'],
//     [12.803488, 78.274763, 'Gudupalli', 'GDP'],
//     [12.842600, 78.249933, 'Bisanattam', 'BSM'],
//     [12.881057, 78.200405, 'Kamasamudram', 'KSM'],
//     [12.922353, 78.191465, 'Varadapura', 'VRDP'],
//     [12.984640, 78.178863, 'Bangarapet Junction', 'BWT'],
//     [12.987259, 78.124553, 'Maralahalli', 'MZV'],
//     // [12.988498, 78.107732, 'Maralahalli', ],
//     [12.984258, 78.070714, 'Tyakal', 'TCL'],
//     [12.994991, 78.018584, 'Byatrayanhalli', 'BFW'], // 12.992717, 78.030223
//     [12.992596, 77.939206, 'Malur', 'MLO'],
//     [12.985510, 77.831409, 'Devangonthi', 'DKN'],
//     [12.996373, 77.761393, 'White Field', 'WFD'],
//     // [12.997894, 77.738994, ],
//     // [12.995838, 77.727354, 'Whitefield Panel Cab', 'WHPC'],
//     [12.996096, 77.718651, 'Hoodi Halt', 'HDIH'],
//     [13.000529, 77.675328, 'Krishnarajapuram', 'KJM'],
//     [12.991953, 77.653428, 'Baiyyappanahalli Cabin', 'BPHI'], // 12.995594, 77.660645
//     [13.001315, 77.618277, 'Bangalore East', 'BNCE'],
//     [12.993580, 77.597977, 'Bengaluru Cantt.', 'BNC'],
//     [12.978549, 77.569443, 'Bengaluru City Junction', 'SBC'],
//     // [12.978567, 77.569495, 'Krishnadevaraya Halt', 'KNDV'],
//     [12.662335, 78.406978, 'Mulanur', 'MAR'],
//     [12.586495, 78.469811, 'Patchur', 'PU'],
//     [12.574847, 78.542696, 'Somanayakkanpatti', 'SKPT'],
//     [12.563345, 78.577783, 'Jolarpettai Junction', 'JTJ'],
// ]

// function drawRailwayMarkers() {
//     let station_markers = [];
//     stations.forEach(f => {
//         let marker = new window.google.maps.Marker({
//             icon: {
//                 url: stationmarker,
//                 scaledSize: new window.google.maps.Size(38, 38),
//             },
//             position: {
//                 lat: f[0],
//                 lng: f[1],
//             },
//             title: f[2] || 'N/A',
//             map: window.map,
//         });
//         station_markers.push(marker);
//     });
//     window.station_markers = station_markers;
// }
const timeValue = {}

class SearchComponent extends Component {
  state = {
    searching: false,
    searchstr: "",
    searchrslt: [],
    searchfocus: 0,
  };
  componentDidMount() {
    window.addEventListener("keydown", this.keylistener);
    this.setState({ searchrslt: this.props.reports.map((r) => r.name) });
    window.onEscape("reportsearch", () => {
      if (this.state.searching) {
        this.setState({ searching: false });
        return false;
      }
    });
  }
  componentWillUnmount() {
    window.removeEventListener("keydown", this.keylistener);
    if ("reportsearch" in window.escapeListeners)
      delete window.escapeListeners["inmultiselect"];
  }
  keylistener = (e) => {
    if (e.ctrlKey && e.keyCode === 80 && this.props.reportWindow.visible) {
      e.preventDefault();
      this.setState(
        { searching: !this.state.searching },
        () => this.state.searching && this.refs.search.select()
      );
    }
    if (
      e.ctrlKey &&
      (e.keyCode === 221 || e.keyCode === 219) &&
      this.props.reportWindow.visible
    ) {
      let current = this.props.reportWindow.tab.key;
      let idx = _.findIndex(this.props.reports, ["key", current]);
      let lastidx = this.props.reports.length - 1;
      let target_idx;
      // right square bracket
      if (e.keyCode === 221) target_idx = idx === lastidx ? 0 : idx + 1;
      // left square bracket
      if (e.keyCode === 219) target_idx = idx === 0 ? lastidx : idx - 1;
      if (target_idx > -1 && target_idx < this.props.reports.length) {
        this.props.changeTab(this.props.reports[target_idx]);
        document.activeElement.blur();
      }
    }
    if (e.keyCode === 40 && e.target === this.refs.search) {
      let { searchfocus, searchrslt } = this.state;
      this.setState({
        searchfocus:
          searchfocus === searchrslt.length - 1 ? 0 : searchfocus + 1,
      });
    }
    if (e.keyCode === 38 && e.target === this.refs.search) {
      let { searchfocus, searchrslt } = this.state;
      this.setState({
        searchfocus:
          searchfocus === 0 ? searchrslt.length - 1 : searchfocus - 1,
      });
    }
    if (e.keyCode === 13 && e.target === this.refs.search) {
      let filterd = this.getFilteredReports();
      this.props.changeTab(filterd[this.state.searchfocus]);
      this.setState({
        searching: false,
        searchstr: "",
        searchrslt: this.props.reports.map((r) => r.name),
      });
    }
  };

  getFilteredReports = () => {
    let reports = this.props.reports;
    let { searchstr } = this.state;
    if (!searchstr) return reports;
    let regex = new RegExp(".*" + searchstr + ".*", "i");
    let filterd = reports.filter((r) => regex.test(r.name));
    return filterd;
  };

  searchComponent = (e) => {
    let searchstr = e.target.value;
    let state = { searchstr, searchfocus: 0 };
    if (searchstr !== this.state.searchstr) {
      let filterd = this.getFilteredReports();
      state.searchrslt = filterd.map((r) => r.name);
    }
    this.setState(state);
  };

  render() {
    if (this.state.searching)
      return (
        <div className="rw-search">
          <div className="rw-search-i">
            <input
              type="text"
              ref="search"
              onChange={this.searchComponent}
              value={this.state.searchstr}
            />
          </div>
          <div className="rw-search-l">
            {this.state.searchrslt.map((r, i) => (
              <div
                key={i}
                className={
                  "rw-search-li" + (this.state.searchfocus === i ? " fcs" : "")
                }
              >
                {r}
              </div>
            ))}
          </div>
        </div>
      );
    return null;
  }
}
export const startLiveData = (props) => {
  let schema = props.reportWindow.tab
  window.liveFlag = false
  window.renderCanTable = true
  if(!window.canDataVehicle) return
  if(schema.key === 'jem_can_data_report'){
    getjemCanDataReport(schema)
    window.liveDataInterval = setInterval(() => {
    getjemCanDataReport(schema)
  }, 10000);
  }
  else if(schema.key=== 'bg_can_data_report'){
    getbgCanDataReport(schema)
  window.liveDataInterval = setInterval(() => {
    getbgCanDataReport(schema)
  }, 10000);
  }
  else{
    getCanDataReport(schema)
    window.liveDataInterval = setInterval(() => {
    getCanDataReport(schema)
  }, 10000);
  }
}

class ReportWindow extends Component {
  state = {
    snaplive: false,
    graphExpand: false,
    closeButton: true,
    rawdata:false,
    toggleOn: false
  
  };

  constructor(props) {
    super(props);

    let localData = {};

    this.isTabSelected = (tab) => {
      return this.props.reportWindow && this.props.reportWindow.tab
        ? this.props.reportWindow.tab.key === tab.key
        : false;
    };
    window.forceUpdateReportWindow = () => {
      this.forceUpdate();
    };

    window.setReportWindowTabBusy = (schema, status) => {
      schema.busy = status;
      this.forceUpdate();
    };

    this.isJupiter = () => {
      let path = this.props.groupTree.children[0].path;
      if(path) {
        let groupids = path.split("/");
        for (let idx in groupids) {
          if (parseInt(groupids[idx]) === 6426) {
            return true
          }
        }
      }
     
    }
    this.openTab = () => {
      const auth = window.getAuth();
      const url = `https://apidrishti.jupiterelectricmobility.com/sso-login?token=${auth.token}`;
      window.open(url, '_blank'); 
    }
    this.closeWindow = (action = null) => {
      window.setReportName = false
      if (action === null || this.props.reportWindow.visible != action) {
        window.$(".rw-container").attr("style", function (i, style) {
          return style && style.replace(/top[^;]+;?/g, "");
        });
        this.changeTab(this.getReports()[0]);
        this.setState({snaplive: false})
        window.snaplive = false
        window.canData = []
        window.toggleReportWindow = !window.toggleReportWindow
        props.dispatch({
          type: actions.TOGGLE_REPORT_WINDOW,
        });
      }
      if (window.polyline) window.polyline.setMap(null);
      if (window.startMarker) window.startMarker.setMap(null)
      if (window.endMarker) window.endMarker.setMap(null)
      if (window.pointerMarker) window.pointerMarker.setMap(null)
        window.setMapSize({
          height: window.innerHeight - 50,
          width: window.innerWidth - 50,
          top: 0,
          left: 0,
      });
    };

    this.changeTab = (tab) => {
      if (
        props.reportWindow &&
        props.reportWindow.tab &&
        props.reportWindow.tab.key === tab.key
      )
        return;
      if(this.props.reportWindow.visible){
          document.title = "Track - "+tab.name
      }
      window.graphDataErr = ''  
      window.selectedVehiclesUpdatedAt = Date.now();
      // init window.selectedVehicles
      // required by reports with vehicle dropdown(virtually every report)
      // moved from history_report
      let vht = _.find(tab.toolbar, ["key", "vehicle"]);
      if (vht && !window.selectedVehicles) {
        // Check if vehicleMap exists and has vehicles
        if (props.vehicleMap && Object.keys(props.vehicleMap).length > 0) {
          let id = Object.keys(props.vehicleMap)[0];
          let sv = props.vehicleMap[id];
          // Check if vehicle exists and has required properties
          if (sv && sv.vehicleno) {
            window.selectedVehicles = [{ id, name: sv.vehicleno, data: sv }];
          } else {
            // Fallback: set empty array if vehicle data is incomplete
            window.selectedVehicles = [];
            console.warn('ReportWindow: Vehicle data incomplete, selectedVehicles set to empty array');
          }
        } else {
          // Fallback: set empty array if vehicleMap is empty
          window.selectedVehicles = [];
          console.warn('ReportWindow: vehicleMap is empty or undefined, selectedVehicles set to empty array');
        }
      }
      props.dispatch({
        type: actions.TOGGLE_REPORT_WINDOW_TAB,
        data: tab,
      });
      if (window.setAddrBox) window.setAddrBox("");
      if(tab.key === "can_data_dump_report"){
        setTimeout(() => {
          changeVehicle(window.selectedVehicles,tab.key)
        },1000)

      }
      if(tab.key === "jem_can_data_dump_report"){
        setTimeout(() => {
          changeVehicle(window.selectedVehicles,tab.key)
        },100)
      }

      if(tab.key === "bg_can_data_dump_report"){
        setTimeout(() => {
          changeVehicle(window.selectedVehicles,tab.key)
        },100)
      }

    };

    this.getToolBar = (reportWindow) => {
      return reportWindow.tab && reportWindow.tab.toolbar
        ? reportWindow.tab.toolbar
        : [];
    };
    this.clearData = (val,tool) => {
      val =  moment(val).unix() * 1000 
      if(tool.key === "starttime"){
        timeValue.starttime = val
      }
      if(tool.key === "endtime"){
        timeValue.endtime = val
      }
      if(val)window.currentValue = timeValue
      if(this.props && this.props.reportWindow && this.props.reportWindow.tab.key === "can_data_dump_report"){
        if(window.dumpTime && (window.dumpTime .starttime !== timeValue.starttime || window.dumpTime.endtime !== timeValue.endtime)){
          window.dumpTime .starttime = timeValue.starttime
          window.dumpTime.endtime = timeValue.endtime
          let key = this.props.reportWindow.tab.key
          changeVehicle(window.selectedVehicles,key)
        }
      }
    }
    this.onChangeTime = (val) => {
      let startDate = val
      window.hourlyStartTime = startDate
    }

    this.onButtonClick = (Tool) => {
      let callback = Tool.onClick ? Tool.onClick : Tool.onChange;
      setTimeout(() => {
        if (callback) {
          let data = {};
          let tool;
          for (let idx in this.props.reportWindow.tab.toolbar) {
            tool = this.props.reportWindow.tab.toolbar[idx];
            if (tool.ref && tool.ref.getData) {
              data[tool.key] = tool.ref.getData();
            } else if (tool.ref && "value" in tool.ref) {
              data[tool.key] = tool.ref.value;
            }
          }
          callback(
            this.props.reportWindow.tab,
            data,
            {
              vehicleMap: this.props.vehicleMap,
              graphSetState: this.props.graphSetState,
              dispatch: this.props.dispatch,
              groupTree: this.props.groupTree || [],
              store:this.props.storeStates
            },
            Tool
          );
        }
      }, 100);
    };

    //initial
    // this.setRef = (tool, ref) => {
    //   tool.ref = ref && ref.wrappedInstance ? ref.wrappedInstance : ref;
    // };
    this.setRef = (tool, ref) => {
      if (!ref) {
        return;
      }
      tool.ref = ref;
    }; 
    this.getGraphConfig = (tool) => {
      return {
        width: tool._position.width,
        height: tool._position.height,
        type: tool.graphType,
        ticks: tool.ticks,
        pointerTime: tool.pointerTime,
      };
    };

    this.graphExpanded = (val) => {
      this.setState({
        graphExpand: val,
      });
    };

    this.closeButton = (val) => {
      this.setState({
        closeButton: val,
      });
    };
    this.validateTool = (tool) => {
      return !tool.isShowable || tool.isShowable(tool, this.props);
    };

    this.isDisabled = (tool) => {
      return !(!tool.isDisabled || tool.isDisabled(tool, this.props));
    };

    this.getTool = (tool, index) => {
      if (!this.validateTool(tool)) {
        return null;
      }

      let el;
      switch (tool.type) {
        case schemaTypes.MULTI_SELECT:
          el = (
            <InMultiSelect
              data={tool}
              key={index}
              ref={(ref) => {
                this.setRef(tool, ref);
              }}
            />
          );
          break;

          case schemaTypes.TOGGLE:
            el = (
              <Toggle
                 selected={this.state.rawdata}
                 toggleSelected={() => {
                  this.setState({ rawdata: !this.state.rawdata });
                    }}
                />
            );
            break;

            case schemaTypes.TOGGLE2:
              el = (
                <Toggle2
                   toggleState={this.state.toggleOn}
                   toggleFun={() => {
                    this.setState({ toggleOn: !this.state.toggleOn });
                      }}
                  />
              );
              break;
              case schemaTypes.SNAPTOGGLE:
              el = (
                <SnapToggle
                  selected={this.state.snaplive}
                   toggleSelected={() => {
                    if(!window.canDataVehicle){
                      this.props.dispatch({
                        type: "ADD_INTOAST",
                        data: {
                          name: "Please Select a Vehicle",
                          content: "Please select a vehicle to get CAN data report",
                          createAt: Date.now(),
                          autoClose: 8000,
                          showError:true
                        },
                      });                  
                      return
                    }
                    this.setState({ snaplive: !this.state.snaplive },() => {
                      if(this.state.snaplive === true){
                        window.renderCanTable = true
                        startLiveData(this.props)
                      }else{
                        clearInterval(window.liveDataInterval)
                        window.renderCanTable = false
                      }
                    });
                      }}
                  />
              );
              break;

        case schemaTypes.BUTTON:
          el = (
            <div
              className="rwt-button"
              ref={(ref) => {
                this.setRef(tool, ref);
              }}
              title={tool.tooltip}
              onClick={() => this.onButtonClick(tool)}
              key={index}
            >
              {this.getIcon(tool)}
              {tool.name}
            </div>
          );
          break;

        case schemaTypes.INPUT:
          el = (
            <input
              className="rwt-input"
              defaultValue={tool.model}
              ref={(ref) => {
                this.setRef(tool, ref);
              }}
              onChange={() => this.onButtonClick(tool)}
              key={index}
            />
          );
          break;
          case schemaTypes.GROUP_SELECT:
          el = (
            <GroupSelect />
          );
          break;

        case schemaTypes.INPUT_NUMBER:
          el = (
            <input
              className="rwt-input"
              defaultValue={tool.model}
              type="number"
              placeholder={tool.placeholder}
              ref={(ref) => {
                this.setRef(tool, ref);
              }}
              onChange={() => this.onButtonClick(tool)}
              key={index}
            />
          );
          break;


        case schemaTypes.DATE_PICKER:
          el = (
            <InDatePicker
              data={tool}
              ref={(ref) => {
                this.setRef(tool, ref);
              }}
              key={index}
              onChange = { (val) => this.clearData(val,tool)}
            />
          );
          break;
        case schemaTypes.DATE_PICKER2:
          el = (
            <DatePicker2
              data={tool}
              ref={(ref) => {
                this.setRef(tool, ref);
              }}
              key={index}
              onChange = { (val) => this.onChangeTime(val,tool)}
            />
          );
          break;

        case schemaTypes.MOBILEYE_REPORT_TOOLBAR:
          el = (
            <MobileyeReportToolBar
              data={tool}
              resume={this.getResumeData(tool)}
              saveState={this.saveState}
              schemaKey={this.getKey()}
              config={this.getGraphConfig(tool)}
              ref={(ref) => {
                this.setRef(tool, ref);
              }}
              key={index}
            />
          );
          break;

        case schemaTypes.IN_GRAPH:
          el = (
            <InGraph
              data={tool}
              lines={tool.config}
              resume={this.getResumeData(tool)}
              saveState={this.saveState}
              schemaKey={this.getKey()}
              config={this.getGraphConfig(tool)}
              ref={(ref) => {
                this.setRef(tool, ref);
              }}
              key={index}
            />
          );
          break;

        case schemaTypes.IN_GRAPH_CONTROL:
          el = (
            <InGraphControl
              graphExpand={this.state.graphExpand}
              closeBut={this.state.closeButton}
              data={tool}
              ref={(ref) => {
                this.setRef(tool, ref);
              }}
              schemaKey={this.getKey()}
              resume={this.getResumeData(tool,"test")}
              saveState={this.saveState}
              // vehicle={this.props.selectedVehicle}
              vehicle = {window.selectedVehicles ? window.selectedVehicles : {}}
              key={index}
            />
          );
          break;

        case schemaTypes.IN_GRAPH_SET:
          el = (
            <InGraphSet
              graphExpanded={this.graphExpanded}
              closeButton={this.closeButton}
              data={tool}
              resume={this.getResumeData}
              saveState={this.saveState}
              schemaKey={this.getKey()}
              ref={(ref) => {
                this.setRef(tool, ref);
              }}
              key={index}
            />
          );
          break;

        case schemaTypes.IN_TABLE:
          el = (
            <InTable
              saveState={this.saveState}
              schemaKey={this.getKey()}
              resume={this.getResumeData(tool)}
              ref={(ref) => {
                this.setRef(tool, ref);
              }}
              data={tool}
              auth={this.props.auth}
              groupTree={this.props.groupTree || []}
              key={index}
              selectedVehicleId = {this.props.selectedVehicleId}
            />
          );
          break;
        case schemaTypes.IN_PIE_CHART:
          el = (
            <InPieChart
              saveState={this.saveState}
              schemaKey={this.getKey()}
              resume={this.getResumeData(tool)}
              ref={(ref) => {
                this.setRef(tool, ref);
              }}
              data={tool}
              key={index}
            />
          );
          break;
        case schemaTypes.INFO:
          el = (
            <LiabilityGuage
              ref={(ref) => {
                this.setRef(tool, ref);
              }}
            />
          );
          break;

        case schemaTypes.ADVANCED_FUEL_REPORT:
          el = (
            <AdvandedFuelReport
              saveState={this.saveState}
              resume={this.getResumeData(tool)}
              ref={(ref) => this.setRef(tool, ref)}
              data={tool}
            />
          );
          break;

        case schemaTypes.IN_GREY_SPOTTER:
          el = (
            <InGreySpotter
              saveState={this.saveState}
              schemaKey={this.getKey()}
              resume={this.getResumeData(tool)}
              ref={(ref) => {
                this.setRef(tool, ref);
              }}
              data={tool}
              key={index}
            />
          );
          break;

        case schemaTypes.AGGREGATED_REPORT:
          el = (
            <AggregatedReport
              saveState={this.saveState}
              schemaKey={this.getKey()}
              resume={this.getResumeData(tool)}
              ref={(ref) => {
                this.setRef(tool, ref);
              }}
              data={tool}
              key={index}
            />
          );
          break;

          case schemaTypes.DOWNLOAD_REPORT:
          el = (
            <DownloadReport
              saveState={this.saveState}
              schemaKey={this.getKey()}
              resume={this.getResumeData(tool)}
              ref={(ref) => {
                this.setRef(tool, ref);
              }}
              data={tool}
              key={index}
              allowedReports = {this.allowedReports}
              props={this.props}
            />
          );
          break;

          case schemaTypes.UTILIZATION_REPORT:
          el = (
            <MonthlyReport
              saveState={this.saveState}
              schemaKey={this.getKey()}
              resume={this.getResumeData(tool)}
              ref={(ref) => {
                this.setRef(tool, ref);
              }}
              data={tool}
              key={index}
              allowedReports = {this.allowedReports}
              props={this.props}
            />
          );
          break;


          case schemaTypes.GROUP_REPORT:
          el = (
            <GroupReport
            allowedReports = {this.allowedReports}
            props={this.props}
            data={tool}
             
            />
          );
          break;

          case schemaTypes.TRIP_WISE_REPORT:
          el = (
            <TripwiseReport
            allowedReports = {this.allowedReports}
            props={this.props}
            data={tool}
            />
          );
          break;
          case schemaTypes.CMD_STATUS_REPORT:
            el = (
              <CmdStatusReport
              allowedReports = {this.allowedReports}
              props={this.props}
              data={tool}
               
              />
            );
            break;
        
          case schemaTypes.EV_REPORT:
            el = (
              <EVReport
                saveState={this.saveState}
                schemaKey={this.getKey()}
                resume={this.getResumeData(tool)}
                ref={(ref) => {
                  this.setRef(tool, ref);
                }}
                data={tool}
                key={index}
              />
            );
            break;

        case schemaTypes.TVS_REPORT_WIDGET:
          el = (
            <TVSReportWidget
              saveState={this.saveState}
              schemaKey={this.getKey()}
              resume={this.getResumeData(tool)}
              ref={(ref) => {
                this.setRef(tool, ref);
              }}
              vehicleMap={this.props.vehicleMap}
              data={tool}
              key={index}
            />
          );
          break;

          case schemaTypes.SWIGGY_WIDGET:
            el = (
              <SwiggyWidget
                saveState={this.saveState}
                schemaKey={this.getKey()}
                resume={this.getResumeData(tool)}
                ref={(ref) => {
                  this.setRef(tool, ref);
                }}
                vehicleMap={this.props.vehicleMap}
                data={tool}
                key={index}
              />
            );
            break;

        case schemaTypes.CANDATA_REPORT:
          el = (
            <CanDataReport
              saveState={this.saveState}
              schemaKey={this.getKey()}
              resume={this.getResumeData(tool)}
              ref={(ref) => {
                this.setRef(tool, ref);
              }}
              vehicleMap={this.props.vehicleMap}
              data={tool}
              key={index}
            />
          );
          break;  

            
        case schemaTypes.RAILWAY_REPORT_WIDGET:
          el = (
            <RailwayReportWidget
              saveState={this.saveState}
              schemaKey={this.getKey()}
              resume={this.getResumeData(tool)}
              ref={(ref) => {
                this.setRef(tool, ref);
              }}
              vehicleMap={this.props.vehicleMap}
              data={tool}
              key={index}
            />
          );
          break;

        case schemaTypes.TRIP_DETAILS_WIDGET:
          el = (
            <TripDetailsWidget
              saveState={this.saveState}
              schemaKey={this.getKey()}
              resume={this.getResumeData(tool)}
              ref={(ref) => {
                this.setRef(tool, ref);
              }}
              data={tool}
              auth={this.props.auth}
              groupTree={this.props.groupTree || []}
              key={index}
            />
          );
          break;

        default:
          el = null;
      }
      tool.triggerClick = () => {
        this.onButtonClick(tool);
      };
      tool.getSchema = () => {
        return this.props.reportWindow.tab;
      };

      if (tool.wrapper) {
        return <InWidgetWrapper data={tool}>{el}</InWidgetWrapper>;
      }

      return el;
    };

    this.getContent = (reportWindow) => {
      return reportWindow.tab && reportWindow.tab.content
        ? reportWindow.tab.content
        : [];
    };

    let top = 95;
    let left = 50;
    let right = 0;
    let bottom = 0;
    let width;
    let height;
    let cols = 12;
    let rows = 12;
    let v_unit;
    let h_unit;

    this.getPosition = (tool) => {
      if (!("position" in tool)) return { display: "none" };

      width = window.innerWidth - right - left;
      if (tool.key === "aggregated_report" || tool.key === "ev_report" || tool.key === "download_report" || tool.key === "group_report" || tool.key === "tripwise_report") {
        height = window.innerHeight - top - bottom + 40;
      } else {
        height = window.innerHeight - top - bottom;
      }

      v_unit = height / rows;
      h_unit = width / cols;
      this.unit = { x: h_unit, y: v_unit };
      // if(tool.key === "download_report"){
      //   tool._position = {
      //     ...(tool.style || {}),
      //     position: "relative",
      //     height: v_unit * tool.position.height + 50,
      //     width: h_unit * tool.position.width,
      //     top: v_unit * tool.position.top,
      //     left: h_unit * tool.position.left,
      //   };
      //   return tool._position
      // }
      tool._position = {
        ...(tool.style || {}),
        position: "fixed",
        height: v_unit * tool.position.height,
        width: h_unit * tool.position.width,
        top: v_unit * tool.position.top,
        left: h_unit * tool.position.left,
      };

      return tool._position;
    };

    window.updateReportWindow = () => {
      let gWidth = 6;
      let curTab = this.props.reportWindow.tab;
      if (curTab.key === "history_report") {
        gWidth = 12 - curTab.content[1].position.width;
      }
      window.setMapSize(
        {
          height: this.unit.y * 12 - 40,
          width: this.unit.x * (12 - (gWidth * this.props.graphSetState) / 100),
          top: 45,
          left: 0,
        },
        window.bufferMapResize
      );
      this.forceUpdate();
    };

    window.addEventListener("resize", () => {
      this.forceUpdate();
    });

    this.saveState = (data, key, widget) => {
   
      if (!(key in localData)) {
        localData[key] = {};
      }

      localData[key][widget.key] = {
        state: _.cloneDeep(data),
      };
    };

    this.getKey = () => {
      return this.props.reportWindow && this.props.reportWindow.tab
        ? this.props.reportWindow.tab.key
        : null;
    };

    this.getResumeData = (widget,test) => {
      let key = this.getKey();
      if (localData && localData[key] && widget.key in localData[key]) {
        return localData[key][widget.key];
      }
      return {};
    };

    this.getIcon = (tab) => {
      if (tab.icon) {
        switch (tab.iconType) {
          default:
            return <i className={"rwtt-icon " + tab.icon}></i>;
        }
      }
    };

    this.validateSelectedTab = () => {
      let reports = this.getReports();
      let found = false;
      for (let idx in reports) {
        if (
          this.props.reportWindow &&
          this.props.reportWindow.tab &&
          this.props.reportWindow.tab.key === reports[idx].key
        ) {
          found = true;
        }
      }
      if (!found) {
        this.changeTab(this.getReports()[0]);
      }
    };

    this.vehicleUpdated = (vehicle) => {
      this.validateSelectedTab();
      this.forceUpdate();
      window.afrdata = null;
    };

    window.onEscape("reportWindow", () => this.closeWindow(false));
    window.addOnSaveVehicleStateListener("reportWindow", this.vehicleUpdated);

    this.tabMap = {
      compactor_report: {
        validate: (vehicles) => {
          for (let idx in vehicles) {
            if (
              vehicles[idx] &&
              vehicles[idx].data &&
              vehicles[idx].data.vehiclemeta &&
              vehicles[idx].data.vehiclemeta.model === "Compactor"
            ) {
              return true;
            }
          }
          return false;
        },
      },
      paver_report: {
        validate: (vehicles) => {
          for (let idx in vehicles) {
            if (
              vehicles[idx] &&
              vehicles[idx].data &&
              vehicles[idx].data.vehiclemeta &&
              vehicles[idx].data.vehiclemeta.model === "Asphalt Paver P5320"
            ) {
              return true;
            }
          }
          return false;
        },
      },
      clutch_report: {
        validate: (vehicles) => {
          return (
            this.props.userInfo &&
            this.props.userInfo.SELF &&
            this.props.userInfo.SELF.reports &&
            this.props.userInfo.SELF.reports.indexOf("clutch_report") !== -1
          );
        },
      },
      panic_alert_report: {
        validate: (vehicles) => {
          return (
            this.props.userInfo &&
            this.props.userInfo.SELF &&
            this.props.userInfo.SELF.reports &&
            this.props.userInfo.SELF.reports.indexOf("panic_alert_report") !==
              -1
          );
        },
      },
      mobili_report: {
        validate: (vehicles) => {
          return (
            this.props.userInfo &&
            this.props.userInfo.SELF &&
            this.props.userInfo.SELF.reports &&
            this.props.userInfo.SELF.reports.indexOf("mobili_report") !== -1
          );
        },
      },
      grey_spot_report: {
        validate: (vehicles) => {
          return true;
        },
      },
      geofence_report: {
        validate: () => {
          return ((this.props.geofenceMap || {}).data || []).length;
        },
      },
      advanced_fuel_report: {
        validate: (vehicles) => {
          let groups = ((this.props.groupTree || []).children || []).map(
            (f) => f.name
          );
          let enabled_groups = [
            "Sureeco",
            "IntercityTransport",
            "Orange",
            "JSW",
          ];
          return enabled_groups.map((g) => groups.includes(g)).includes(true);
        },
      },
      tvs_report: {
        validate: (vehicles) => {
          let reports = _.get(this.props, "userInfo.SELF.reports", []);
          return reports.includes("tvs_report");
        },
      },
      tvs_swiggy_report: {
        validate: (vehicles) => {
          let reports = _.get(this.props, "userInfo.SELF.reports", []);
          return reports.includes("tvs_swiggy_report");
        },
      },

      can_data_report: {
        validate: (vehicles) => {
          let reports = _.get(this.props, "userInfo.SELF.reports", []);
          return true
        },
      },

      jem_can_data_report: {
        validate: (vehicles) => {
          let reports = _.get(this.props, "userInfo.SELF.reports", []);
          return true
        },
      },

      bg_can_data_report: {
        validate: (vehicles) => {
          let reports = _.get(this.props, "userInfo.SELF.reports", []);
          return true
        },
      },

      can_data_dump_report: {
        validate: (vehicles) => {
          let reports = _.get(this.props, "userInfo.SELF.reports", []);
          return true
        },
      },

      daily_report_minimal: {
        advancedReport: false,
        validate: (vehicles) => {
          return (
            this.props.userInfo &&
            this.props.userInfo.SELF &&
            this.props.userInfo.SELF.reports &&
            this.props.userInfo.SELF.reports.indexOf("daily_report_minimal") !==
              -1
          );
        },
      },
      railways_report: {
        validate: (vehicles) => {
          let groups = ((this.props.groupTree || []).children || []).map(
            (f) => f.name
          );
          return groups.includes("IRCTC");
        },
      },
      trip_details_report: {
        validate: (vehicles) => {
          return (
            this.props.userInfo &&
            this.props.userInfo.SELF &&
            this.props.userInfo.SELF.reports &&
            this.props.userInfo.SELF.reports.indexOf("trip_details_report") !==
              -1
          );
        },
      },
      bms_report: {
        validate: (vehicles) => {
          return (
            this.props.userInfo &&
            this.props.userInfo.SELF &&
            this.props.userInfo.SELF.reports &&
            this.props.userInfo.SELF.reports.indexOf("bms_report") !== -1
          );
        },
      },
      ev_report: {
        validate: () => {
          return _.get(this.props.groupTree, 'children', [])
            .map(f => window.userGroups[0].groupid===f.groupid)
            .includes(true)
        }
      },
    };
    this.custumTab = {
      grey_spot_report: {
        validate: (vehicles) => {
          return (
            this.props.userInfo &&
            this.props.userInfo.SELF &&
            this.props.userInfo.SELF.reports &&
            this.props.userInfo.SELF.reports.indexOf("grey_spot_report") !== -1
          );
        },
      },
      gps_report: {
        validate: (vehicles) => {
          return (
            this.props.userInfo &&
            this.props.userInfo.SELF &&
            this.props.userInfo.SELF.reports &&
            this.props.userInfo.SELF.reports.indexOf("gps_report") !== -1
          );
        },
      },
      alarm_report: {
        validate: (vehicles) => {
          return (
            this.props.userInfo &&
            this.props.userInfo.SELF &&
            this.props.userInfo.SELF.reports &&
            this.props.userInfo.SELF.reports.indexOf("alarm_report") !== -1
          );
        },
      },
      overpseeding_report: {
        validate: (vehicles) => {
          return (
            this.props.userInfo &&
            this.props.userInfo.SELF &&
            this.props.userInfo.SELF.reports &&
            this.props.userInfo.SELF.reports.indexOf("overpseeding_report") !==
              -1
          );
        },
      },
      trip_report: {
        validate: (vehicles) => {
          return (
            this.props.userInfo &&
            this.props.userInfo.SELF &&
            this.props.userInfo.SELF.reports &&
            this.props.userInfo.SELF.reports.indexOf("trip_report") !== -1
          );
        },
      },

      // mileage_report: {
      //   validate: (vehicles) => {
      //     return (
      //       this.props.userInfo &&
      //       this.props.userInfo.SELF &&
      //       this.props.userInfo.SELF.reports &&
      //       this.props.userInfo.SELF.reports.indexOf("mileage_report") !== -1
      //     );
      //   },
      // },
      summary_report: {
        validate: (vehicles) => {
          return (
            this.props.userInfo &&
            this.props.userInfo.SELF &&
            this.props.userInfo.SELF.reports &&
            this.props.userInfo.SELF.reports.indexOf("summary_report") !== -1
          );
        },
      },
      refuel_report: {
        validate: (vehicles) => {
          return (
            this.props.userInfo &&
            this.props.userInfo.SELF &&
            this.props.userInfo.SELF.reports &&
            this.props.userInfo.SELF.reports.indexOf("refuel_report") !== -1
          );
        },
      },
      pilferage_report: {
        validate: (vehicles) => {
          return (
            this.props.userInfo &&
            this.props.userInfo.SELF &&
            this.props.userInfo.SELF.reports &&
            this.props.userInfo.SELF.reports.indexOf("pilferage_report") !== -1
          );
        },
      },
      geofence_report: {
        validate: (vehicles) => {
          return (
            this.props.userInfo &&
            this.props.userInfo.SELF &&
            this.props.userInfo.SELF.reports &&
            this.props.userInfo.SELF.reports.indexOf("geofence_report") !== -1
          );
        },
      },
      daily_report: {
        validate: (vehicles) => {
          return (
            this.props.userInfo &&
            this.props.userInfo.SELF &&
            this.props.userInfo.SELF.reports &&
            this.props.userInfo.SELF.reports.indexOf("daily_report") !== -1
          );
        },
      },
    };

    this.validateTab = (tab) => {
      let disableReports = _.get(window.userInfo,"SELF.disable_reports")
      let addReports = _.get(window.userInfo,"SELF.reports")
      let peakReport = _.get(window.userInfo, "SELF.enable_peak_report")
        let utilizationReport = _.get(window.userInfo,"SELF.enable_utilization_report")
      if(disableReports !== undefined && disableReports.length && disableReports.includes(tab.key)) return false
      // console.log("addReports",tab);
      
      if(tab.key === 'download_report'){
        return true
      }
      if(tab.key === 'utilization_report'){
        if(utilizationReport !== undefined && utilizationReport){
          return true
        }else {
          return false
        }
      }
      if(tab.key === 'group_report'){
        if(addReports !== undefined && addReports.includes(tab.key)){
          return true
        }else {
          return false
        }
      }
      if(tab.key === 'zap_report'){
        if(addReports !== undefined && addReports.includes(tab.key)){
          return true
        }else {
          return false
        }
      }
      if(tab.key === 'jem_can_data_dump_report'){
        if(addReports !== undefined && addReports.includes(tab.key)){
          return true
        }else {
          return false
        }
      }
      if(tab.key === 'bg_can_data_dump_report'){
        if(addReports !== undefined && addReports.includes(tab.key)){
          return true
        }else {
          return false
        }
      }
      if(tab.key === 'jem_can_data_report'){
        if(addReports !== undefined && addReports.includes(tab.key)){
          return true
        }else {
          return false
        }
      }
      if(tab.key === 'bg_can_data_report'){
        if(addReports !== undefined && addReports.includes(tab.key)){
          return true
        }else {
          return false
        }
      }
      if(tab.key === 'mileage_report'){
        if(addReports !== undefined && addReports.includes(tab.key)){
          return true
        }else {
          return false
        }
      }
      if(tab.key === 'tripwise_report') {
        if(addReports !== undefined && addReports.includes(tab.key)){
          return true
        }else {
          return false
        }
      }
      if(tab.key === 'cmd_status_report') {
        if(addReports !== undefined && addReports.includes(tab.key)){
          return true
        }else {
          return false
        }
      }
      if(tab.key === 'charge_report'  ){
        if(addReports !== undefined &&addReports.includes(tab.key)){
          return true
        }else {
          return false
        }
      }
      if(tab.key === 'hourly_report'){
        if(addReports !== undefined && addReports.includes(tab.key)){
          return true
        }else {
          return false
        }
      }
      if(tab.key === "peak_hour_report" ) {
        if(peakReport !== undefined && peakReport){
          return true
        }else {
          return false
        }
      }
      if(tab.key === 'can_daily_report'){
        if(addReports !== undefined && addReports.includes(tab.key)){
          return true
        }else {
          return false
        }
      }
      if(tab.key === 'range_report'){
        if(addReports !== undefined && addReports.includes(tab.key)){
          return true
        }else {
          return false
        }
      }
      if(tab.key === 'immob_report'){
        if(addReports !== undefined && addReports.includes(tab.key)){
          return true
        }else {
          return false
        }
      }
      let groups = _.get(this.props, "groupTree.children", []).map(
        (f) => f.name
      );
     
      // disabling reports, group level
      if (groups.includes("IRCTC")) {
        let shown_reports = ["history_report", "gps_report", "railways_report"];
        if (!shown_reports.includes(tab.key)) return false;
      }
      if (groups.includes("zoomcar")) {
        let remove_reports = ["grey_spot_report", "pilferage_report"];
        if (remove_reports.includes(tab.key)) return false;
      }
      
      if (groups.includes("TVSmotors") || groups.includes("TVS_Swiggy")) {
        let remove_reports = ["refuel_report", "pilferage_report"];
        if (remove_reports.includes(tab.key)) return false;
      }

      // if(groups.includes('FG_Nssm') && tab.key !== 'daily_report') return false;
      let hideAdvancedReports =
        _.get(window.userInfo, "SELF.advanced_reports") === "HIDE";
      if (
        hideAdvancedReports &&
        tab.key !== "history_report" &&
        (!this.tabMap[tab.key] || this.tabMap[tab.key].advancedReport !== false)
      ) {
        return false;
      }
      let groupChild = this.props.groupTree.children
      if(tab.key === "trip_report"){
        if(window.userInfo.SELF.enable_EV_trip_report === true){
          return true
          }
      }
      if(tab.key === "new_trip_report"){
        if(window.userInfo.SELF.enable_new_trip_report === true){
          return true
        }else return false
      }
      // if(tab.key === "mileage_report"){
      //   if(window.userInfo.SELF.enable_mileage_report === true){
      //     return true
      //   }else return false
      // }
      // if(tab.key in this.custumTab && adv_reports === 'SHOW' ) {
      //     return this.custumTab[tab.key].validate(window.selectedVehicles, tab);
      // }
      if(this.props.groupTree && this.props.groupTree.children ){
        const gTree = []
        const groups = this.props.groupTree.children;
        const gPath = [];
        for(let i in groups) {
          if(groups[i].path){
            gTree.push(groups[i].path)
            // if(gTree[i])gPath.push(gTree[i].split('/').filter(f => f).map(f => parseInt(f, 10)));
            gTree.map((item) => {
              if(item){
                gPath.push(item.split('/').filter(f => f).map(f => parseInt(f, 10)));
              }
            })
          }
        }
        // path selection
        let evGroup = window.evGroups;
        let surgeGroup = []
        if(window.surgeGroups){
          surgeGroup = window.surgeGroups.map((group) => {
            return group.groupid
          }) 
        }
        
        let setForEv = ['history_report', 'gps_report', 'alarm_report', 'overpseeding_report', 'aggregated_report', 'daily_report', 'summary_report', 'can_data_report','jem_can_data_report', 'can_data_dump_report','bg_can_data_report']
        let selectedReports = window.userInfo.SELF.reports
        for(let idx in gPath){
          let groupPath = gPath[idx];
          for(let ndx in groupPath){
            for(let rdx in surgeGroup){
              if(groupPath[ndx] === surgeGroup[rdx]) {
                setForEv.push('ev_report')
              }
            }
            for(let ldx in evGroup){
              if(groupPath[ndx] === evGroup[ldx]){
                if(selectedReports)selectedReports.map((item) => {
                  setForEv.push(item)
                })
                if(!setForEv.includes(tab.key)) return false;
              }
            }
          } 
        }
      }

      // let groupChild = this.props.groupTree.children
      // if(tab.key == 'trip_report' && groupChild && window.evGroups && window.evGroups.includes(groupChild[0].groupid)){
      //  if(window.userInfo.SELF.enable_EV_trip_report != true){
      //   return false
      //  }
      // }

      
      // if(tab.key == 'ev_report' && groupChild && groupChild[0] && !window.evGroups.includes(groupChild[0].groupid)){
      //   return false
      // }
      if(tab.key === 'ev_report' && groupChild && window.surgeGroups){
        let surgeGroup = []
        surgeGroup = window.surgeGroups.map((group) => {
          return group.groupid
        }) 
        for(let idx in groupChild) {
          if(groupChild[idx].groupid !== 0) {
            if(surgeGroup.includes(groupChild[idx].groupid)) {
              return true 
            }else {
              return false
            }
          }
        }
      }
        
      if (tab.key in this.tabMap) {
        return this.tabMap[tab.key].validate(window.selectedVehicles, tab);
      }
      return true;
    };

    this.getReports = () => {
      this.allowedReports = this.props.reports ? this.props.reports.filter((item) => {
        return this.validateTab(item)
      }):[]
      return this.props.reports
        ? this.props.reports.filter((item) => {
            return this.validateTab(item);
          })
        : [];
    };

    this.resize = () => {
      clearTimeout(this.resizeTimeout);
      this.resizeTimeout = setTimeout(() => {
        this.setReportWindowMap(this.props, true);
        this.forceUpdate();
      }, 400);
    };

    window.addEventListener("resize", () => {
      this.resize();
    });

    this.setReportWindowMap = (props, force = false) => {
      // if (window.refreshRefuelGraph) {
      //   window.refreshRefuelGraph();
      // }
      // if (window.refreshPilferageGraph) {
      //   window.refreshPilferageGraph();
      // }
      if(props && props.reportWindow && props.reportWindow.tab && props.reportWindow.tab.key && 
        this.props && this.props.reportWindow && this.props.reportWindow.tab && this.props.reportWindow.tab.key){
            if( props.reportWindow.tab.key !== this.props.reportWindow.tab.key){
            window.refreshRefuelGraph();
            window.refreshPilferageGraph();
          }
      }
      if (this.windowVisible && !props.reportWindow.visible) {
        window.setMapSize({
          height: window.innerHeight - 50,
          width: window.innerWidth - 50,
          top: 0,
          left: 0,
        });
        window.google.maps.event.trigger(window.map, "resize");
        this.windowVisible = false;

        if (window.polyline) {
          window.polyline.setMap(null);
        }

        if (window.alarmMarkers) {
          for (let idx in window.alarmMarkers) {
            if (window.alarmMarkers[idx] && window.alarmMarkers[idx].setMap) {
              window.alarmMarkers[idx].setMap(null);
            }
          }
        }

        if (window.startMarker) {
          window.startMarker.setMap(null);
          window.pointerMarker.setMap(null);
          window.endMarker.setMap(null);
        }

        if (window.clearRefuelMarkers) window.clearRefuelMarkers();
        if (window.clearPilferageMarkers) window.clearPilferageMarkers();

        (window.station_markers || []).forEach((m) => m.setMap(null));
      } else if (
        (force && props.reportWindow.visible) ||
        (!this.windowVisible && props.reportWindow.visible) ||
        (props.reportWindow.visible &&
          this.currentGraphSetState != props.graphSetState)
      ) {
        this.currentGraphSetState = props.graphSetState;
        let gWidth = 6;
        // if(props.reportWindow.tab.key === 'history_report') {
        //     gWidth = 12 - props.reportWindow.tab.content[1].position.width;
        // }
        window.setMapSize(
          {
            height: this.unit.y * 12 - 40,
            width: this.unit.x * (12 - (gWidth * props.graphSetState) / 100),
            top: 45,
            left: 0,
          },
          window.bufferMapResize
        );
        window.google.maps.event.trigger(window.map, "resize");
        this.windowVisible = true;

        if (window.polyline && !window.bufferMapResize) {
          window.polyline.setMap(window.map);
        }

        if (window.alarmMarkers && !window.bufferMapResize) {
          for (let idx in window.alarmMarkers) {
            if (window.alarmMarkers[idx] && window.alarmMarkers[idx].setMap) {
              window.alarmMarkers[idx].setMap(window.map);
            }
          }
        }

        if (window.startMarker && !window.bufferMapResize) {
          window.startMarker.setMap(window.map);
          window.pointerMarker.setMap(window.map);
          window.endMarker.setMap(window.map);
        }
        let groups = ((this.props.groupTree || []).children || []).map(
          (f) => f.name
        );
        // if(groups.includes('IRCTC')) drawRailwayMarkers();
      }
      ReactGA.pageview(
        props.reportWindow.visible ? props.reportWindow.tab.key : "landing_page"
      );
      IntAnalytics.pageView({
        page_id: props.reportWindow.visible
          ? props.reportWindow.tab.key
          : "landing_page",
      });
      if (window.map) {
        window.mapCenter = window.map.getCenter();
        if (!window.mapCenter || !window.mapCenter.lat || !window.mapCenter.lng)
          return;
        // if(window.startMarker) { window.startMarker.setVisible(props.reportWindow.visible)}
        // if(window.endMarker) { window.endMarker.setVisible(props.reportWindow.visible)}
        // if(window.pointerMarker) { window.pointerMarker.setVisible(props.reportWindow.visible)}
        window.map.panTo(window.mapCenter);
      }
    };

    this.getTabBusy = (tab) => {
      if (tab.busy) {
        return <span className="rwtt-spinner"></span>;
      }
    };
  }

  // componentWillReceiveProps(props) {
  //   if( window.snaplive && window.snaplive === true){
  //     if(props && this.props && props.reportWindow.tab.key !== this.props.reportWindow.tab.key ){
  //       clearInterval(window.liveDataInterval)
  //       if(props.reportWindow.tab.key === "can_data_report"){
  //         // startLiveData()
  //       }
  //     }
  //     if(window.liveFlag === true){
  //       if(props.reportWindow.tab.key === "can_data_report"){
  //         // startLiveData()
  //       }
  //     }
  //   }
  //   this.setReportWindowMap(props);
  //   if (!props.reportWindow.visible && this.props.reportWindow.visible) {
  //     if (window.setAddrBox) window.setAddrBox("");
  //   }
  // }

  componentDidMount() {
    let reports = this.getReports();
    window.setReportName = false
    if (this.props.reportWindow.tab === null && reports[0]) {
      // set initial report, history_report by default
      this.changeTab(reports[0]);
    }
    window.addEventListener("keydown", this.keylistener);
  }
  componentWillReceiveProps (props) {
    if(window.toggleReportWindow === true && window.setReportName === false) {
      document.title = "Track - "+props.reportWindow.tab.name
      window.setReportName = true
    }
    if(props.reportWindow.visible !== this.props.reportWindow.visible && props.reportWindow.visible === false) {
      document.title = "Track"
    }
    if(props.reportWindow.visible && window.setReportName === false) {
      document.title = "Track - "+props.reportWindow.tab.name
      window.setReportName = true
    }
    if(props.reportWindow.visible !== this.props.reportWindow.visible && props.reportWindow.visible){
      window.setMapSize({
        height: window.innerHeight - 50,
        width: window.innerWidth - 50,
        top: 45,
        left: 0,
      });
    }else if(props.reportWindow.visible !== this.props.reportWindow.visible && !props.reportWindow.visible) {
      window.setMapSize({
        height: window.innerHeight - 50,
        width: window.innerWidth - 50,
        top: 0,
        left: 0,
      });
    }
    if(props && this.props && this.props.reportWindow && this.props.reportWindow.tab && this.props.reportWindow.tab.key && props.reportWindow &&
      props.reportWindow.tab && props.reportWindow.tab.key && props.reportWindow.tab.key !== this.props.reportWindow.tab.key ){
      clearInterval(window.liveDataInterval)
      if(props.reportWindow.tab.key === "can_data_report" && window.snaplive){
        startLiveData(props)
      }
    }
    if(props && this.props && this.props.reportWindow && this.props.reportWindow.tab && this.props.reportWindow.tab.key && props.reportWindow &&
      props.reportWindow.tab && props.reportWindow.tab.key && props.reportWindow.tab.key !== this.props.reportWindow.tab.key ){
      clearInterval(window.liveDataInterval)
      if(props.reportWindow.tab.key === "jem_can_data_report" && window.snaplive){
        startLiveData(props)
      }
    }
    if(props && this.props && this.props.reportWindow && this.props.reportWindow.tab && this.props.reportWindow.tab.key && props.reportWindow &&
      props.reportWindow.tab && props.reportWindow.tab.key && props.reportWindow.tab.key !== this.props.reportWindow.tab.key ){
      clearInterval(window.liveDataInterval)
      if(props.reportWindow.tab.key === "bg_can_data_report" && window.snaplive){
        startLiveData(props)
      }
    }
    if (!props.reportWindow.visible && this.props.reportWindow.visible) {
      if (window.setAddrBox) window.setAddrBox("");
    }
  }

  componentWillUnmount() {
    window.setReportName === false
    window.removeEventListener("keydown", this.keylistener);
  }

  keylistener = (e) => {
    if (e.keyCode === 13 && e.ctrlKey) {
      let { toolbar } = this.props.reportWindow.tab;
      let button = _.find(
        toolbar,
        (f) => f.key === "get_history" && f.type === "BUTTON"
      );
      if (button && button.ref) button.ref.click();
    }
    if(e.keyCode === 27) {
      window.toggleReportWindow = false
    }
  };

  render() {
    return (
      <div
        className={Dom.Class(
          { active: this.props.reportWindow.visible },
          "ReportWindow"
        )}
      >
        <SearchComponent
          reportWindow={this.props.reportWindow}
          changeTab={this.changeTab}
          reports={this.getReports()}
        />
        <div
          className="rw-tabs"
          style={{
            left: getLogoWidth(),
          }}
        >
          {this.getReports().map((tab, index) => {
            return (
              <div
                className={Dom.Class(
                  { active: this.isTabSelected(tab) },
                  "rwt-tab"
                )}
                onClick={() => this.changeTab(tab)}
                key={index}
              >
                {this.getIcon(tab)}
                {this.getTabBusy(tab)}
                {tab.name}
              </div>
            );
          })}
          {this.isJupiter() ? <button className="new-tab-btn" onClick={() => this.openTab()}>DRISHTI</button> : null}
          <div
            className="closeButton"
            onClick={() => this.closeWindow()}
          >
            X
          </div>
        </div>
        {this.getToolBar(this.props.reportWindow) ? (
          this.getToolBar(this.props.reportWindow).length > 0 ? (
            <div className="rw-toolbar">
              {this.getToolBar(this.props.reportWindow)
                .filter((tool) => {
                  return this.validateTool(tool);
                })
                .map((tool, index) => {
                  return (
                    <div
                      className={Dom.Class(
                        {
                          "-right": tool.alignRight,
                          "-icon": tool.icon,
                          "-disabled": this.isDisabled(tool),
                        },
                        "rwt-tool"
                      )}
                      key={index}
                    >
                      {this.getTool(tool, tool.uid)}
                    </div>
                  );
                })}
            </div>
          ) : null
        ) : null}
        {this.getContent(this.props.reportWindow) ? (
          <div className="rw-container">
            <div className="rwc-content">
              {this.getContent(this.props.reportWindow).map((tool, index) => {
                return (
                  <div
                    className={
                      "rwt-widget" + (!this.validateTool(tool) ? " -hide" : "")
                    }
                    style={this.getPosition(tool)}
                    key={index}
                  >
                    {this.getTool(tool, tool.uid)}
                  </div>
                );
              })}
            </div>
          </div>
        ) : null}
      </div>
    );
  }
}

const MapPropsToState = (state) => {
  return {
    reportWindow: state.reportWindow,
    vehicleMap: state.vehicleMap,
    graphSetState: state.graphSetState,
    selectedVehicle: state.selectedVehicle,
    userInfo: state.userInfo,
    geofenceMap: state.geofenceMap,
    groupTree: state.groupTree,
    graphSize: state.graphSize,
    auth: state.auth,
    storeStates:state,
    selectedVehicleId : state.selectedVehicleId,
  };
};

export default connect(MapPropsToState)(ReportWindow);